import React, {useEffect, useState} from "react";
import {Button, Input, Typography} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import {submitOtp} from "../../services/otp/otp";
import {Toaster} from "../../helper/Toaster";

const OtpField = ({className, label, onChange, time, userPhone, setCodeSent}) => {
  const [timer, setTimer] = useState(0);
  const [value, setValue] = useState("test");
  const [phone, setPhone] = useState(userPhone);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);

      // Clear the interval when the component unmounts or timer becomes 0
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleClick = () => {
    sendPhone()
    setTimer(time || 120);
  };

  const sendPhone = async () => {
    if (userPhone.length === 11) {
      const data = {
        phone: userPhone,
      };

      let result;

      result = await submitOtp(data);

      if (result.status === 201) {
        setCodeSent(true);
      }
    } else {
      Toaster.failure(null, <Typography variant={"small"}>
        شماره همراه صحیح نیست
      </Typography>);
    }
  };

  return (
    <div className={`${className} flex flex-row w-full overflow-x-clip gap-x-4`}>
      <Input
        className="w-full appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        variant="standard"
        value={value}
        type="number"
        label={label ? Dict('label') : 'کد دریافتی'}
        placeholder={label ? Dict('label') : 'کد دریافتی'}
        onChange={(e) => {
          onChange(e.target.value);
          setValue(e.target.value);
        }}
      />
      <Button
        className="rounded-xl w-auto "
        loading={timer > 0}
        onClick={handleClick}
        disabled={timer > 0}
      >
        {timer > 0 ? timer : 'دریافت کد'}
      </Button>
    </div>
  );
};

export default OtpField;
